import axios from '../../plugins/axios';
import { Message } from 'element-ui';

export const blogCategories_module = {
    state: ()=>({
        pending: false,
        loadingMore: false,
        data: {
            current_page: 1,
            data: [],
            last_page: null,
            searchedKeyword:'',
            filter:{
                status:[],
                indexed:[],
                type:[],
            },
            allFilters:[],
        },
        message: null,
        success: null,
        error: null
    }),
    mutations: {
        fetch_blogCategories_request(state,loadingType){
            
            if(loadingType == 'new'){

                state.pending = true;

            }else if(loadingType == 'more'){

                state.loadingMore = true;

            }

        },
        fetch_blogCategories_success(state, payload){

            if(payload.loadData == 'new'){

                state.data.data = payload.categories.data

            }else if(payload.loadData == 'more'){

                state.data.data.push(...payload.categories.data);

            }

            state.data.current_page = payload.categories.current_page
            state.data.last_page = payload.categories.last_page
            state.pending = false;
            state.loadingMore = false;
            state.success = true;
            state.error = null;
            state.message = payload.message;

        },
        fetch_blogCategories_failure(state, payload){

            state.data.data = [];
            state.pending = false;
            state.loadingMore = false;
            state.success = false;
            state.error = payload.error;
            state.message = payload.message

        },
        add_blogCategories_list(state,payload){

            state.data.data.unshift(payload);

        },
        update_blogCategories_list(state,payload){

            const index = state.data.data.findIndex(x=>x.id === payload.id)
  
            if(index !== -1){

                state.data.data[index] = payload;

            }

            state.data.data.forEach((category) => { 

                if(category.parent_id && (category.parent_id == state.data.data[index].id)){
                
                    category.parents[0].name = state.data.data[index].name;
                
                }

            });

        },
        update_blogCategories_status(state,payload){

            state.data.data[payload.index].isActive = payload.updatedBlogCategory.isActive

            if(payload.updatedBlogCategory.isActive == 0){

                state.data.data.forEach((category)=>{ 

                    if(category.parent_id && (category.parent_id == payload.updatedBlogCategory.id)){

                        category.parent_id = null;

                        category.parents = [];

                    }

                });

            }

        },
        delete_blogCategories_list(state,payload){

            let tempCategory = state.data.data[payload]

            state.data.data.forEach((category)=>{ 

                if(category.parent_id && (category.parent_id == tempCategory.id)){

                    category.parent_id = null

                    category.parents = []

                }

            });

            state.data.data.splice(payload,1);
    
        },
        categories_bulk_action(state,payload){
            
            if(payload.action == 'delete'){

                state.data.data = state.data.data.filter((category)=>{

                    if(!payload.listIds.includes(category.id)){

                        return category;

                    }else{

                        if(category.created_by_user == null){

                            return category;

                        }

                    }

                });

            }else if(payload.action == 'statusChange'){

                state.data.data.forEach((category) =>{

                    if(payload.listIds.includes(category.id)){

                        category.isActive = payload.status;

                    }
                    if(payload.listIds.includes(category.parent_id) && payload.status == 0){

                        category.parent_id = null;

                        category.parents = [];
                        
                    }

                });

            }else if(payload.action == 'isIndexed'){

                state.data.data.forEach((category) => {

                    if(payload.listIds.includes(category.id)){

                        category.isIndexed = payload.indexed;

                    }

                });

            }
            
        },
        update_searched_keyword(state,payload){ 

            state.data.searchedKeyword = payload.keyword

        },
        remove_searched_keyword(state){
            
            state.data.allFilters = []

            state.data.searchedKeyword = ''

        },
        update_blog_category_filters(state,payload){

            state.data.filter.status = payload.status
            state.data.filter.indexed = payload.indexed
            state.data.filter.type = payload.type

        },
        update_blog_category_all_filters(state,payload){
            
            state.data.allFilters = payload

        },
        remove_blog_category_filters(state){

            state.data.filter.status = []
            state.data.filter.type = []
            state.data.filter.indexed = []

        },
        CLEAR_MODULE(state){

            state.pending = false
            state.loadingMore = false;
            state.message = null
            state.success = null
            state.error = null

            state.data.current_page = 1
            state.data.data = []
            state.data.last_page = null,
            state.data.searchedKeyword = ''
            state.data.filter = {
                status:[],
                indexed:[],
                type:[],
            }
            state.data.allFilters = []

        },
    },
    actions:{
        async fetchStoreBlogCategoriesRequest({commit},{size, page, loadData}){

            commit('fetch_blogCategories_request',loadData);

            let status = this.state.blogCategories_module.data.filter.status[0];
            let indexed = this.state.blogCategories_module.data.filter.indexed[0];
            let type = this.state.blogCategories_module.data.filter.type[0];
            const searchedKeyword = this.state.blogCategories_module.data.searchedKeyword;

            try{
                let res = await axios.get('/blog-category/all',{
                    params:{
                        search: searchedKeyword.length > 0 ? searchedKeyword : null,
                        offset: size,
                        page: page,
                        active: status ? status == 'active' ? 1 : 0 : null,
                        indexed: indexed ? indexed == 'indexed' ? 1 : 0 : null,
                        type: type ? type : null,
                    }
                });
                if(res.data.status_code == '1042'){

                    res.data.loadData = loadData

                    commit('fetch_blogCategories_success', res.data)

                }
            }catch(ex){

                Message({
                    type: 'error',
                    showClose: true,
                    message: ex.response ? ex.response.data.message : ex.message,
                });
                
                commit('fetch_blogCategories_failure', {error: ex, message: ex})

            }
            
        }
    },
    getters: {
        blogCategories(state){

            return state.data.data;

        },
        isPending(state){

            return state.pending;

        },
        isLoadingMore(state){

            return state.loadingMore;

        },
        filters(state){

            return state.data.filter;

        },
        allFilters(state){

            return state.data.allFilters;

        },
        currentPage(state){

            return state.data.current_page;

        },
        lastPage(state){

            return state.data.last_page;

        },
        keyword(state){

            return state.data.searchedKeyword;

        },
        message(state){

            return state.message;
            
        },
        error:(state)=>state.error
    }
}